import { Component, OnInit } from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FormBuilder } from '@angular/forms';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpClient} from '@angular/common/http';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent} from'src/app/layout/layout.component';

@Component({
  selector: 'app-ModuleManagement',
  templateUrl: './wmsm-ModuleManagement.component.html',
  styleUrls: ['./wmsm-ModuleManagement.component.css']
})
export class WmsmModuleManagementComponent extends BaseComponent implements OnInit {
  loading: boolean;

    // 表格每页显示条数,默认每頁顯示10筆資料
    pageSize: number = 20;
    // 表格页码
    pageIndex: number = 1;
    nzTotal: number = 0;
    listOfData: any[] = [];
    fileList: NzUploadFile[] = [];

  ExcelControl = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ];
  constructor(
    private Environment: EnvironmentconfigService,
    private webApiService: WebApiService,
    private messageService: NzMessageService,
    private AuthService: AuthService,
    private fb: FormBuilder,
    private http: HttpClient,
    private matomotracker:MatomoTracker,
    private LayoutComponent:LayoutComponent
  ) { super() }

  ngOnInit() {
    this.getResultData()
    this.matomotracker.trackPageView("系統管理員權限設置")
    this.matomotracker.trackEvent("系統管理員權限設置","模块管理","Transation",1);
    this.validateForm = this.fb.group({
      
    });

    this.LayoutComponent.geturl()
   
  }

  //切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  //切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  getResultData(){
    this.loading =true
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetHrSiteMappingList.url}`;
    const params = {
      data:{}
    };
    this.webApiService.doGet(url, params).subscribe(
      (res) => {
        this.listOfData=res.sort((a, b) => a.siteNo.localeCompare(b.siteNo));
        this.loading =false
      },
      (error) => {
       
      }
    );
  }

//关闭大陆对账
  onOffchStatement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {    
    data:{
       siteNo:data.siteNo,
       status:"N",
       column:"1"
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//开启大陆对账
onopenchStatement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {
    data:{
      siteNo:data.siteNo,
       status:"Y",
       column:"1"
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//关闭台湾对账
onOfftwStatement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {    
    data:{
      siteNo:data.siteNo,
       status:"N",
       column:"0"
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()


    },
    (error) => {
     
    }
  );
}

//开启台湾对账
onopentwStatement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {
    data:{
      siteNo:data.siteNo,
      status:"Y",
      column:"0"
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//关闭交期
onOffdeliveryMaintain(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {    
    data:{
      siteNo:data.siteNo,
      status:"N",
      column:"2"
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()


    },
    (error) => {
     
    }
  );
}

//开启交期
onopendeliveryMaintain(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {
    data:{
      siteNo:data.siteNo,
      status:"Y",
      column:"2"
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//开启合同
onopenContractCooperationManagement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {
    data:{
      siteNo:data.siteNo,
      status:"Y",
      column:"3"
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//关闭交期
onOffContractCooperationManagement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {    
    data:{
      siteNo:data.siteNo,
      status:"N",
      column:"3"
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()


    },
    (error) => {
     
    }
  );
}

//开启寻源
onopenSourcingPricingManagement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {
    data:{
      siteNo:data.siteNo,
      status:"Y",
      column:"4"
    }
  };
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()

    },
    (error) => {
     
    }
  );
}

//关闭寻源
onOffSourcingPricingManagement(data){
  const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateModelStatus.url}`;
  const params = {    
    data:{
      siteNo:data.siteNo,
      status:"N",
      column:"4"
  }};
  this.webApiService.doPost(url, params).subscribe(
    (res) => {

        this.getResultData()


    },
    (error) => {
     
    }
  );
}

}
